import { render } from "./SampleApprovalDialog.vue?vue&type=template&id=3024755f&scoped=true"
import script from "./SampleApprovalDialog.vue?vue&type=script&lang=js"
export * from "./SampleApprovalDialog.vue?vue&type=script&lang=js"

import "./SampleApprovalDialog.vue?vue&type=style&index=0&id=3024755f&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3024755f"],['__file',"src/components/orders/SampleApprovalDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3024755f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3024755f', __exports__)) {
    console.log('reload')
    api.reload('3024755f', __exports__)
  }
  
  module.hot.accept("./SampleApprovalDialog.vue?vue&type=template&id=3024755f&scoped=true", () => {
    console.log('re-render')
    api.rerender('3024755f', render)
  })

}


export default __exports__